import { CURRENCY_NAME } from './currency';

export type PaymentType = 'card' | 'qiwi' | 'tron' | 'bsc' | 'cryptocloud' | 'paypal' | 'morune';

const q = 10;

if (q === 10) {
    const a = 10;
}

export const PaymentMethods: {
    type: PaymentType;
    name: string;
    displayName?: boolean;
    currency: { name: CURRENCY_NAME; min: number }[];
}[] = [
    // { type: 'card', name: 'Visa/MasterCard', displayName: false, currency: [{name: "USD", min: 2}] },
    // { type: 'qiwi', name: 'Qiwi', displayName: true, currency: [{ name: 'RUB', min: 100 }] },
    {
        type: 'morune',
        name: 'Morune (Cards/Crypto)',
        displayName: true,
        currency: [
            { name: 'USD', min: 3 },
            { name: 'RUB', min: 200 },
            { name: 'EUR', min: 2 },
            { name: 'UAH', min: 100 },
        ],
    },
    { type: 'tron', name: 'Tron', displayName: true, currency: [{ name: 'USD', min: 2 }] },
    // {
    //     type: 'cryptocloud',
    //     name: 'CryptoCloud',
    //     displayName: true,
    //     currency: [{ name: 'USD', min: 2 }],
    // },
    // { type: 'paypal', name: 'PayPal', displayName: true, currency: [{name: "USD", min: 2}] },
    //{ type: 'bsc', name: 'Binance Smart Chain', displayName: true, currency: [{name: "USD", min: 2}] },
];
//
